const binding = { modules: {}, dataActions: {} };

    (binding.modules['mtt-tile-list'] = {
        c: () => require('partner/modules/mtt-tile-list/mtt-tile-list.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mtt-tile-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mtt-tile-list'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mtt-tile-list|mtt-tile-list'] = {
                c: () => require('partner/modules/mtt-tile-list/mtt-tile-list.view.tsx'),
                cn: '__local__-__local__-mtt-tile-list'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };